import React from "react";
import { IProgressPayment, progressPaymentSchema } from "../../interfaces/IProgressPayment";
import { Box, Card, CardContent, Grid, IconButton, Typography } from "@mui/material";
import { Add, AddCircle, AddCircleOutline, AddOutlined, Delete } from "@mui/icons-material";
import { CustomeTextField } from "../core/CustomeTextField";

interface IProps {
    progressPayment: IProgressPayment | null;
    setProgressPayment: Function;
}


export const InvoiceProgressPaymentEdit:React.FC<IProps> = ({
    progressPayment,
    setProgressPayment
}) => {

    const handleOnAdd = () => {
        setProgressPayment(progressPaymentSchema.parse({}))
    }

    const handleRemove = () => {
        setProgressPayment(null);
    }


    if (progressPayment === null) {
        return(
            <Card 
                variant="outlined"
                sx={{
                    mt: 5,
                    cursor: "pointer"
                }}
                onClick={handleOnAdd}
            >
                <CardContent>
                    <Box
                        sx={{
                            textAlign: "center",
                            display: "flow",
                            mt: 1,
                            mb: -1,
                        }}
                    >
                        <Typography>
                            Abschlagszahlung hinzufügen
                        </Typography>
                        
                        <AddCircleOutline/>
                    </Box>

                </CardContent>
            </Card>
        )
    }

    return(
        <>
            <Typography 
                variant="h6"
                sx={{
                    mt: 4,
                    mb: 2
                }}
            >
                Abschlagszahlung
                <IconButton
                    sx={{
                        float: "right"
                    }}
                    onClick={handleRemove}
                >
                    <Delete/>
                </IconButton>
            </Typography>


            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <CustomeTextField
                        attr="numberOfContract"
                        label="Beauftragungs-/Vertragsnummer"
                        object={progressPayment}
                        setObject={setProgressPayment}
                        type="string"
                        required
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomeTextField
                        attr="dateOfCommissioning"
                        label="Vom"
                        object={progressPayment}
                        setObject={setProgressPayment}
                        type="date"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="total"
                        label="Summe"
                        object={progressPayment}
                        setObject={(upd:IProgressPayment) => setProgressPayment({
                            ...upd,
                            valueToPay: upd.total*upd.percentToPay
                        })}
                        type="euro"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="percentToPay"
                        label="Abschlagszahlung in Prozent"
                        object={progressPayment}
                        setObject={(upd:IProgressPayment) => setProgressPayment({
                            ...upd,
                            valueToPay: upd.total*upd.percentToPay
                        })}
                        type="number"
                        required
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        attr="valueToPay"
                        label="Abschlagszahlung in Euro"
                        object={progressPayment}
                        setObject={(upd:IProgressPayment) => setProgressPayment({
                            ...upd,
                            percentToPay: upd.valueToPay / upd.total
                        })}
                        type="euro"
                        required
                    />
                </Grid>
            </Grid>
        </>
    )
}